export const getCurrentInstance = (url) => {
  const token = url.split('.')[0]
  return token
    .replace(/^https:\/\/|http:\/\//, '')
    .replace(/-devices-dev$/, '')
    .replace(/-devices-qa$/, '')
    .replace(/-devices-uat$/, '')
    .replace(/-devices$/, '')
}

export const createSpaLink = (appDomain, subdomain, instanceName) => {
  const APP_ENV = process.env.REACT_APP_APP_ENV

  const protocol = 'https://'
  const prefix = subdomain.prefix ?? ''
  const subdomainSuffix = subdomain.suffix ?? ''
  const envSuffix = ['prd', 'production'].includes(APP_ENV) ? '' : `-${APP_ENV}`
  const domain = appDomain ?? 'ordernext.com'

  return `${protocol}${prefix}${instanceName}${subdomainSuffix}${envSuffix}.${domain}`
}

export const createLegacyCanopyLink = (path = '') => {
  const ORG = process.env.REACT_APP_ORG
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const ECOSYSTEM = process.env.REACT_APP_ECOSYSTEM

  return `https://canopy.${APP_ENV}.${ECOSYSTEM}.vnops.net/${path}?url_organization_name=${ORG}`
}
